<template>
<div>
    <div class="page">
        <div class="title">登录</div>
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
            <el-form-item prop="xm">
                <el-input placeholder="请输入姓名" prefix-icon="el-icon-s-custom" v-model="form.xm"></el-input>
            </el-form-item>
            <el-form-item prop="sfz">
                <el-input placeholder="请输入身份证号码" prefix-icon="el-icon-user-solid" v-model="form.sfz"></el-input>
            </el-form-item>
            <el-form-item prop="ksh">
                <el-input placeholder="请输入考生号" prefix-icon="el-icon-s-check" v-model="form.ksh"></el-input>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" @click="login('form')" class="logBtn">登 录</el-button>
            </el-form-item>
        </el-form>     
    </div> 
    <div style="margin-top:20px;text-align:center">注:推荐使用Chrome浏览器</div>
</div> 
</template>

<script>
    import {
        loginApi,
        loginSmsApi,
        loginMathApi
    } from '@/api/index';
    export default {
        components: {

        },
        data() {
            return {
                form: {
                    sfz: '',
                    ksh: '',
                    xm: '',
                },
                rules: {
                    sfz: [{
                        required: true,
                        message: '请输入身份证号',
                        trigger: 'blur'
                    }, ],
                    ksh: [{
                        required: true,
                        message: '请输入考生号',
                        trigger: 'blur'
                    }, ],
                    xm: [{
                        required: true,
                        message: '请输入姓名',
                        trigger: 'blur'
                    }, ],
                    
                }
            }
        },
        mounted() {
            localStorage.removeItem("token")
            // this.getMath()
        },
        methods: {
            // 登录
            login(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        loginApi(this.form).then(res => {
                            let token = res.data.token
                            localStorage.setItem('token',token);
                            this.$message.success('登录成功');
                            this.$router.push({ path: 'home'})
                        })
                    } else {
                        this.$message.error('请输入必填信息');
                    }
                });
            }
        },
    }
</script>

<style scoped>
    .el-form-item {
        margin: 0px;
    }

    .el-form {
        margin-left: -100px;
    }

    .page {
        display: flex;
        flex-direction: column;
        /* justify-content: center; */
        align-items: center;
        width: 350px;
        height: 300px;
        margin: 0 auto;
        margin-top: 100px;
        padding: 30px 50px;
        border: 1px solid #cccccc;
    }

    .title {
        width: 100%;
        font-size: 28px;
        color: #838282;
        padding-bottom: 10px;
        border-bottom: 1px solid #cccccc;

    }

    .el-input {
        width: 350px;
        margin-top: 20px;
    }

    .verifyBox {
        display: flex;
        /* justify-content: space-a; */
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .ipt {
        width: 230px;
    }

    .verify {
        height: 40px;
        margin-top: 20px;
        margin-left: 10px;
    }

    .verifyImgBox {
        display: flex;
        /* justify-content: center;  */
        align-items: center;
    }

    .el-image {
        margin-left: 20px;
        margin-top: 20px;
    }

    .logBtn {
        width: 80%;
        margin-top: 30px;
        margin-left: 40px;
    }
</style>